import { appstr } from "../utils/appstr";
import { enumExcelExportScope, enumFieldType, enumIWizDataSet, enumSaveScope } from "../constants";
import { GetFieldDefBy } from "../utils/GetFieldDefBy";
import { QExcelOut } from "./QExcelOut";
import { QUploadExcelJSON } from "./QUploadExcelJSON";
import { Globals } from "./Globals";

export class QExcelExport {
  constructor() {
    this.fObjDB = null;
    this.fCurOrg = null;
    this.fFileName = null;
    this.fDoc = null;
    this.fWSMgr = null;
  }

  Init(theDoc, curUser, curOrg, wsMgr) {
    this.fWSMgr = wsMgr;
    this.fDoc = theDoc;

    this.fObjDB = theDoc.GetObjDB();
    this.fCurOrg = curOrg;
    this.fCurUser = curUser;

    var docMgr = theDoc.GetDocMgr();
    var fn = docMgr.GetFileName(false);

    if (fn == "") fn = appstr("Untitled");
    this.fFileName = fn + ".xls";
  }

  GetSubChartMgr() {
    return this.fDoc.GetSubChartMgr();
  }

  DoExportExcel(
    scope,
    filename,
    fieldDefs = [],
    includeChainOfCommand = false,
    includeSystemFields = true
  ) {
    window.onbeforeunload = null;

    var scm = this.GetSubChartMgr();

    var saveScope = null;
    switch (scope) {
      case enumExcelExportScope.currentbranch:
        saveScope = enumSaveScope.currentBranch;
        break;
      case enumExcelExportScope.currentpage:
        saveScope = enumSaveScope.currentPage;
        break;
      default:
        break;
    }

    if (saveScope != null) {
      var curScope = scm.GetSaveScope();
      scm.SetSaveScope(saveScope);
      scm.FilterObjects(true);
      scm.SetSaveScope(curScope);
    }

    var excelOut = new QExcelOut();
    excelOut.InitJSON(
      this.fObjDB,
      this.fCurOrg,
      this.fFileName,
      scope,
      fieldDefs,
      includeChainOfCommand,
      includeSystemFields
    );

    if (saveScope != null) scm.FilterObjects(false);

    var uploadRFC = new QUploadExcelJSON();
    const promise = uploadRFC.GetPromise();
    uploadRFC.InitRFC(this);

    var jsonData = {
      rows: excelOut.fRowList,
      headers: excelOut.fHeaders,
      headerLabels: excelOut.fHeaderLabels
    };

    var fieldData = [];

    var boxClass = this.fObjDB.GetClassByName("Box");
    for (var aFieldDefIdx in excelOut.fHeaders) {
      var theField = excelOut.fHeaders[aFieldDefIdx];
      var theDataField = { name: theField, type: 0 };
      var theFieldDef = boxClass.GetFieldDefByName(theField);
      if (theFieldDef) {
        var theFieldType = theFieldDef.GetFieldType();
        theDataField["type"] = theFieldType;
        if (theFieldType === enumFieldType.number) {
          var showT = theFieldDef.GetShowThousandsSep();
          var places = theFieldDef.GetNumDecPlaces();
          var percentage = theFieldDef.GetShowPercent();
          var prefix = theFieldDef.GetPrefix();
          var postfix = theFieldDef.GetPostfix();
          theDataField["showT"] = showT;
          theDataField["places"] = places;
          theDataField["percent"] = percentage;
          if (prefix) theDataField["prefix"] = prefix;
          if (postfix) theDataField["postfix"] = postfix;
        } else if (theFieldType === enumFieldType.date) {
        }
      }
      fieldData.push(theDataField);
    }
    jsonData["datatypes"] = fieldData;
    jsonData["filename"] = filename || this.fFileName.replace(".xls", "");
    jsonData["sheetname"] = this.fDoc.GetSubChartMgr().GetActiveSubChartName();
    if (this.fDoc.GetIWizData(enumIWizDataSet.refresh)) {
      var iwizrefresh = this.fDoc.GetIWizData(enumIWizDataSet.refresh);
      jsonData["chartID"] = iwizrefresh.GetBaseChartID();
    }
    uploadRFC.SetParams(this.fCurOrg, this.fCurUser, JSON.stringify(jsonData));
    Globals._rfcMgr.QueueRFC(uploadRFC);

    return promise;
  }

  ExcelJSONResult(success, r) {
    this.fDoc.SetDownloadingExcel(false);

    if (success) {
      var filename = r;
      var w = this.fWSMgr;
      w.DownloadPub(filename);
    }
  }
}
